import { motion } from "framer-motion";

const WORKS = [
  { src: "/gallery/work-1.webp", alt: "Pink French tip acrylic set by Teo's Nails", span: "md:col-span-4", testid: "gallery-item-1" },
  { src: "/gallery/work-2.webp", alt: "Pink French nails with glitter accent by Teo's Nails", span: "md:col-span-4", testid: "gallery-item-2" },
  { src: "/gallery/work-3.webp", alt: "White and black French tip set by Teo's Nails", span: "md:col-span-4", testid: "gallery-item-3" },
  { src: "/gallery/work-4.webp", alt: "Soft pink classic manicure by Teo's Nails", span: "md:col-span-6", testid: "gallery-item-4" },
  { src: "/gallery/work-5.webp", alt: "White French nails with crystal details by Teo's Nails", span: "md:col-span-6", testid: "gallery-item-5" },
];

export const Gallery = () => (
  <section id="gallery" data-testid="gallery-section" className="bg-white py-24 md:py-32">
    <div className="mx-auto max-w-7xl px-6 md:px-12">
      <div className="mb-16 flex flex-wrap items-end justify-between gap-6">
        <div className="max-w-2xl">
          <p className="mb-4 text-xs font-semibold uppercase tracking-[0.2em] text-brand-accent">Recent work</p>
          <h2 className="font-display text-4xl font-medium tracking-tight text-brand-ink md:text-5xl">
            Fresh from the salon
          </h2>
        </div>
        <p className="max-w-xs text-sm leading-relaxed text-brand-ink/60">
          Real sets, real clients — a glimpse of what leaves our table every week.
        </p>
      </div>
      <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 md:grid-cols-12 md:gap-8">
        {WORKS.map((work, i) => (
          <motion.figure
            key={work.src}
            initial={{ opacity: 0, y: 32 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.7, delay: 0.08 * i, ease: [0.22, 1, 0.36, 1] }}
            data-testid={work.testid}
            className={`group overflow-hidden rounded-2xl border border-brand-muted shadow-[0_8px_32px_rgba(45,27,34,0.06)] transition-transform duration-300 hover:-translate-y-1 hover:shadow-lg ${work.span}`}
          >
            <img
              src={work.src}
              alt={work.alt}
              loading="lazy"
              className="aspect-[3/4] w-full object-cover transition-transform duration-500 group-hover:scale-105"
            />
          </motion.figure>
        ))}
      </div>
    </div>
  </section>
);
